import MuiCheckbox, {
  CheckboxProps as MuiCheckboxProps,
} from '@material-ui/core/Checkbox';

import { CheckedIcon, MinusIcon } from 'components/icons';

import clsx from 'clsx';
import { useStyles } from './style';

export interface ActionTableCheckboxProps extends MuiCheckboxProps {}

const ActionTableCheckbox: React.FC<ActionTableCheckboxProps> = (props) => {
  const classes = useStyles();

  return (
    <MuiCheckbox
      classes={{
        root: classes.checkboxRoot,
      }}
      disableRipple
      color="default"
      icon={<span className={classes.checkboxIcon}></span>}
      checkedIcon={
        <span
          className={clsx(classes.checkboxIcon, classes.checkedCheckboxIcon)}
        >
          <CheckedIcon className={classes.checkIcon} />
        </span>
      }
      indeterminateIcon={
        <span className={classes.checkboxIcon}>
          <MinusIcon className={classes.indeterminateIcon} />
        </span>
      }
      {...props}
    />
  );
};

export default ActionTableCheckbox;
